import React from 'react';
import { NavLink } from 'react-router-dom';
import { Clock, Calendar, BarChart3, FolderKanban, Settings, Shield } from 'lucide-react';

export function TabNav({ isAdmin }) {
  const tabs = [
    { path: '/timer', label: 'Timer', icon: Clock },
    { path: '/timeline', label: 'Timeline', icon: Calendar },
    { path: '/reports', label: 'Reports', icon: BarChart3 },
    { path: '/projects', label: 'Projects', icon: FolderKanban },
    { path: '/settings', label: 'Settings', icon: Settings },
  ];

  // Add Admin tab if user is admin
  if (isAdmin) {
    tabs.push({ path: '/admin', label: 'Admin', icon: Shield });
  }

  return (
    <div className="border-b border-gray-200 bg-gray-50">
      <div className="flex">
        {tabs.map(({ path, label, icon: Icon }) => (
          <NavLink
            key={path}
            to={path}
            className={({ isActive }) =>
              `flex-1 flex items-center justify-center gap-2 py-4 font-medium transition-colors ${
                isActive
                  ? 'text-blue-600 border-b-2 border-blue-600 bg-white'
                  : 'text-gray-600 hover:text-gray-900'
              }`
            }
          >
            <Icon size={20} />
            {label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
